<script setup lang="ts">
import CustomCloseButton from '@/components/createdUi/CustomCloseButton.vue'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'
import type { ISocialLink } from '@/utils/socialLinks'

const props = defineProps<{
  social: ISocialLink | null
}>()

const isOpen = defineModel<boolean>({ default: false })

const feedbackStore = useFeedbackStore()
const { copy, isSupported } = useClipboard({ legacy: true })

function openLink() {
  if (props.social)
    window.open(props.social.url, '_blank', 'noopener')
}

async function copyLink() {
  if (!props.social)
    return

  try {
    if (!isSupported.value)
      throw new Error('Clipboard API недоступен')

    await copy(props.social.url)
    feedbackStore.showToast({ type: 'success', message: 'Ссылка скопирована' })
  }
  catch (error) {
    console.error('Не удалось скопировать ссылку:', error)
    feedbackStore.showToast({ type: 'error', message: 'Не удалось скопировать ссылку' })
  }
}
</script>

<template>
  <VDialog
    v-model="isOpen"
    max-width="400"
  >
    <VCard
      v-if="social"
      class="social-qr-dialog pa-6 pt-10"
    >
      <CustomCloseButton
        class="social-qr-dialog__close"
        :close-action="() => (isOpen = false)"
      />

      <div class="social-qr-dialog__title text-center">
        Будьте в курсе новостей<br>DAO-MED.ru
      </div>
      <div class="social-qr-dialog__subtitle text-center mt-1">
        {{ social.subtitle }}
      </div>

      <div class="d-flex justify-center my-4">
        <img
          :src="social.qr"
          :alt="`QR-код: ${social.subtitle}`"
          width="180"
          height="180"
        >
      </div>

      <div class="d-flex flex-column gap-3">
        <VBtn
          block
          :color="social.color"
          append-icon="ri-arrow-right-line"
          @click="openLink"
        >
          Перейти
        </VBtn>
        <VBtn
          block
          variant="outlined"
          :color="social.color"
          append-icon="ri-link"
          @click="copyLink"
        >
          Скопировать ссылку
        </VBtn>
      </div>
    </VCard>
  </VDialog>
</template>

<style scoped lang="scss">
.social-qr-dialog {
  position: relative;
}

.social-qr-dialog__close {
  position: absolute;
  inset-block-start: 0.5rem;
  inset-inline-end: 0.5rem;
}

.social-qr-dialog__title {
  color: rgb(var(--v-theme-text-primary));
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
}

.social-qr-dialog__subtitle {
  color: rgb(var(--v-theme-secondary));
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
}
</style>
